import { Box } from '@mui/material';
import React, { useState } from 'react';
import AppHeaderAuth from 'src/components/AppHeaderAuth';
import Sidebar from 'src/components/Sidebar';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarShrunk, setSidebarShrunk] = useState(false);

  // Calculate sidebar width based on shrunk state
  const sidebarWidth = sidebarShrunk ? 72 : 256;

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onShrinkChange={setSidebarShrunk}
      />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: 'background.default',
          ml: { xs: 0, md: `${sidebarWidth}px` },
          width: { xs: '100%', md: `calc(100% - ${sidebarWidth}px)` },
          transition: 'margin-left 0.3s ease-in-out, width 0.3s ease-in-out',
        }}
      >
        <AppHeaderAuth onSidebarToggle={() => setSidebarOpen((prev) => !prev)} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            px: { xs: 2, md: 3 },
            pt: { xs: 2, md: 3 },
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default ProtectedLayout;
